@let hab = habilitation();
@let demandeHab = demandeHabilitation();

<oui-accordion
  class="habiliation__accordion"
  [class.habiliation__accordion--no-content]="!demandeHab || !hab">
  <oui-accordion-header>
    <oui-accordion-title class="habilitation-title">
      @if (isBo() && hab) {
        <oui-slide-toggle
          [control]="activeControl"
          (click)="onActiveToggleClick($event)"></oui-slide-toggle>
      }
      <div class="headline-6">{{ libelle() }}</div></oui-accordion-title
    >
    <oui-accordion-description>
      @if (isBo() && canInitiateParcours()) {
        <oui-button type="text" (click)="initiateParcours.emit()"
          >Initier le parcours</oui-button
        >
      }

      @if (demandeHab) {
        @let currentStatusPresentation = currentStepStatus();
        @if (demandeHab?.statut === 'nc_a_traiter') {
          <oui-icon class="habilitation__icon-invalid">scan_delete</oui-icon>

          <span class="habilitation__text-invalid">
            Un ou plusieurs justificatifs ne sont pas conformes
          </span>
        } @else {
          <oui-icon class="habilitation__icon-transition">schedule</oui-icon>

          <span class="habilitation__text-transition">
            {{ currentStatusPresentation?.label }}
          </span>
        }
      } @else {
        @if (!hab || !hab.actif) {
          @if (hab?.override?.consultantHabilitationTempStatut === false) {
            <oui-icon class="habilitation__icon-disabled">gpp_bad</oui-icon>

            <span class="habilitation__text-disabled"
              >Désactivée depuis le
              {{ hab?.override?.dateAction | date: 'dd/MM/yyyy' }}</span
            >
          } @else {
            <oui-icon class="habilitation__icon-invalid">gpp_bad</oui-icon>
            @if (hab?.dateFin) {
              <span class="habilitation__text-invalid"
                >Non habilité depuis le {{ hab!.dateFin | date: 'dd/MM/yyyy' }}</span
              >
            } @else {
              Non habilité
            }
          }
        } @else {
          <oui-icon class="habilitation__icon-valid" [fill]="true"
            >verified_user</oui-icon
          >
          @if (hab.override?.consultantHabilitationTempStatut === true) {
            <span class="habilitation__text-valid">
              Activée jusqu'au
              {{ hab.override?.dateEcheance | date: 'dd/MM/yyyy' }}
            </span>
          } @else {
            Habilité jusqu'au {{ hab.dateFin | date: 'dd/MM/yyyy' }}
          }
        }
      }
    </oui-accordion-description>
  </oui-accordion-header>
  @if (hab) {
    <div class="habiliation__accordion__content">
      <oui-pair-info
        level="secondary"
        label="Période de validité"
        [value]="
          hab?.dateDebut && hab?.dateFin
            ? 'du ' +
              (hab.dateDebut | date: 'dd/MM/yyyy') +
              ' au ' +
              (hab.dateFin | date: 'dd/MM/yyyy')
            : ''
        "
        [editable]="false"></oui-pair-info>
      @if (commissionAdi()) {
        <oui-pair-info
          level="secondary"
          [editable]="false"
          label="Choix commission ADI"
          [value]="commissionAdi()"></oui-pair-info>
      }
      <oui-pair-info
        level="secondary"
        label="Nom de l'assureur"
        [value]="hab.assureurNom"
        [editable]="false"></oui-pair-info>
      <oui-pair-info
        level="secondary"
        label="Adresse de l'assureur"
        orientation="vertical"
        [value]="hab.assureurAdresse"
        [editable]="false"></oui-pair-info>
      <oui-pair-info
        level="secondary"
        label="Médiateur"
        [value]="hab.mediateur"
        orientation="vertical"
        [editable]="false"></oui-pair-info>
      <oui-pair-info
        level="secondary"
        label="Montant RCP par an et par sinistre"
        [value]="hab.montantRcp?.toString()"
        [editable]="false"></oui-pair-info>
    </div>
  }
</oui-accordion>
